import classes from "./index.module.css";

const MoonIcon: React.FC = () => {
  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      width="66"
      height="69"
      viewBox="0 0 66 69"
    >
      <g
        id="Group_30"
        data-name="Group 30"
        transform="translate(-279.361 -224.819)"
      >
        <path
          id="Union_1"
          data-name="Union 1"
          d="M61.828,68.277,47.162,53.491a2.678,2.678,0,0,1-.227-.262,29.055,29.055,0,0,1-17.6,5.914A29.573,29.573,0,1,1,58.668,29.57a29.6,29.6,0,0,1-8.092,20.395l.042.042L65.285,64.792a2.48,2.48,0,0,1,0,3.484,2.427,2.427,0,0,1-3.457,0ZM4.889,29.57A24.446,24.446,0,1,0,29.333,4.928,24.572,24.572,0,0,0,4.889,29.57ZM24.7,43.6a14.673,14.673,0,1,1,9.277-.005c-.741.146-.975-.314-.975-.71V38.828a3.53,3.53,0,0,0-1.009-2.736c3.266-.366,6.7-1.615,6.7-7.294a5.736,5.736,0,0,0-1.509-3.969,5.359,5.359,0,0,0-.146-3.912s-1.226-.4-4.029,1.515a13.851,13.851,0,0,0-7.346,0c-2.8-1.91-4.03-1.515-4.03-1.515a5.37,5.37,0,0,0-.144,3.918,5.736,5.736,0,0,0-1.51,3.969c0,5.663,3.421,6.931,6.678,7.3a3.172,3.172,0,0,0-.93,1.978,3.11,3.11,0,0,1-4.268-1.23,3.077,3.077,0,0,0-2.249-1.525s-1.43-.019-.1.9a3.908,3.908,0,0,1,1.63,2.162s.849,2.639,4.929,1.742v2.753a.678.678,0,0,1-.716.738A1.373,1.373,0,0,1,24.7,43.6Z"
          transform="translate(279.361 224.819)"
          fill="#27d3a5"
        />
      </g>
    </svg>
  );
};

export default MoonIcon;
